<template>
  <el-dialog
          :title="'批量导出'"
          :close-on-click-modal="false"
          :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px" style="text-align: left">
      <el-form-item label="大队" prop="bmid" >
        <el-select clearable :disabled="deptdisable"   filterable v-model="dataForm.bmid" @change="selectChanged2" placeholder="请选择大队">
          <el-option
                  v-for="item in depts"
                  :key="item.bmid"
                  :label="item.bmmc"
                  :value="item.bmid"
                  :disabled="deptdisable">
          </el-option>
        </el-select>
        <el-select clearable :disabled="deptdisable"   filterable v-model="dataForm.childDeptId"     placeholder="请选择二队">
          <el-option
                  v-for="item in childDepts"
                  :key="item.bmid"
                  :label="item.bmmc"
                  :value="item.bmid"
                  :disabled="deptdisable">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="岗位" prop="Gw" >
        <el-input style="width: 52%;" clearable placeholder="请输入岗位" v-model="dataForm.Gw"></el-input>
      </el-form-item>
      <el-form-item label="日期" prop="month">
        <el-date-picker
                v-model="dataForm.month"
                value-format="yyyy-MM"
                type="month"
                placeholder="选择月">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="导出" >
        <el-button type="primary" v-if="isAuth('export:kq')" @click="exportKq">导出考勤表</el-button>
        <el-button type="primary"  v-if="isAuth('export:kqcollect')"  @click="exportKqCollect">导出汇总表</el-button>
<!--        <el-button type="primary"  v-if="isAuth('export:kqcollectall')"  @click="exportKqCollectAll">导出总表</el-button>-->
        <el-button type="primary"  v-if="isAuth('export:kqcollect')"  @click="exportSchoolKqCollect">导出校园汇总表</el-button>
      </el-form-item>

    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>

    </span>
  </el-dialog>
</template>

<script>
  import { Loading } from 'element-ui';
  export default {
    data () {
      return {
        visible: false,
        type:undefined,
        dataForm: {
          Gw:'',
          childDeptId:'',
          bmid:'',
          month:'',
          file:'',
          filename:''
        },
        depts:[],
        childDepts:[],
        imgList:[],
        deptdisable:false,
        dataRule: {
          bmid: [
            {required: true, message: '部门不能为空', trigger: 'blur'}
          ],
          month: [
            {required: true, message: '日期不能为空', trigger: 'blur'}
          ],
          file: [
            {required: true, message: '请上传文件', trigger: 'blur'}
          ]
        },
      }
    },
    methods: {
      selectChanged2(value) {
            this.currentPage =1
            this.childDepts = []
            this.dataForm.childDeptId = ''
            this.$request({
                method: 'get',
                url: '/bjba/kqtj/getMentForUser2',
                params: {
                    fbmid: value,
                    userid:this.$store.getters.username
                }
            }).then((response) => {
                this.childDepts = response.data;
                var zzdyqc = this.$store.getters.user.zzdyqc;
                if(zzdyqc){
                    if(zzdyqc != this.CONST_ZN_BM) {
                        var zw = this.$store.getters.user.zw;

                        if(zw) {
                            if(zw=='02'||zw=='03') {
                                if(this.childDepts[0]) {
                                    this.childDeptId = this.childDepts[0].bmid
                                }
                            }
                        }
                    }

                }
            }).catch((err) => {
                console.log(err)
            })
        },
      init (type) {
        this.type = type
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          this.imgList=[]
          this.getDepts()
        })

      },
      exportKq(){
        if(this.dataForm.bmid && this.dataForm.month) {
          var viewUrl = this.$request.defaults.baseURL+'/bjba/kqtj/exportExcel?bmid='+this.dataForm.bmid+'&date='+this.dataForm.month+'&childDept='+this.dataForm.childDeptId+'&GW='+this.dataForm.Gw+'&type='+this.type+'&access_token='+this.$store.getters.token
          window.open(viewUrl)
        } else {
          this.$message.error("请选择部门和日期")
        }

      },
      exportKqCollect(){
        if(this.dataForm.bmid && this.dataForm.month) {
          var viewUrl = this.$request.defaults.baseURL + '/bjba/kqtj/exportExcelCollect?bmid=' + this.dataForm.bmid + '&date=' + this.dataForm.month+'&type='+this.type+'&childDept='+this.dataForm.childDeptId+'&GW='+this.dataForm.Gw + '&access_token=' + this.$store.getters.token
          window.open(viewUrl)
        }else {
          this.$message.error("请选择部门和日期")
        }
      },
      // exportKqCollectAll(){
      //   if(this.dataForm.month) {
      //     var viewUrl = this.$request.defaults.baseURL + '/bjba/kqtj/exportExcelCollectAll?date=' + this.dataForm.month + '&access_token=' + this.$store.getters.token
      //     window.open(viewUrl)
      //   } else {
      //       this.$message.error("请选择日期")
      //     }
      // },
      exportSchoolKqCollect(){
        if(this.dataForm.bmid && this.dataForm.month) {
          var viewUrl = this.$request.defaults.baseURL + '/bjba/kqtj/exportSchoolExcelCollect?bmid=' + this.dataForm.bmid + '&date=' + this.dataForm.month+'&type='+this.type+'&childDept='+this.dataForm.childDeptId+'&GW='+this.dataForm.Gw + '&access_token=' + this.$store.getters.token
          window.open(viewUrl)
        }else {
          this.$message.error("请选择部门和日期")
        }
      },
      getDepts() {
        let that = this;
        this.$request.get('/bjba/kqtj/getFirstMentForUser',{
          params: {
            userid:this.$store.getters.username
          }

        }).then(res => {
          that.depts = res.data
          if(this.depts && this.depts[0]) {
            var zzdyqc = this.$store.getters.user.zzdyqc;
            if(this.CONST_MOSTHIGH_DEPTS&&this.CONST_MOSTHIGH_DEPTS.includes&&!this.CONST_MOSTHIGH_DEPTS.includes(zzdyqc)) {
              var zw = this.$store.getters.user.zw;
              if (zw) {
                if (zw == '01' || zw == '02' || zw == '03') {
                  this.dataForm.bmid = that.depts[0].bmid
                  this.deptdisable = true
                  if (zw != '01') {
                    // this.childdeptdisable =true;
                  }
                  // this.selectChanged2(this.form.dept)
                }
              } else {
                // this.selectChanged2(this.form.dept)
              }
            }
          }
        })
      }
    }
  }
</script>
